/**
 * Submodule 동적 라우팅 유틸리티 (방안 B)
 * 단일 라우트 /plugins/:pluginName 으로 플러그인 로드.
 * 접근 허용은 가드에서 백엔드 activePluginNames로만 검사.
 */

import SubmoduleLoader from "@src/views/SubmoduleLoader.vue";

const PLUGIN_BASE_PATH = "/plugins";

class SubmoduleRouter {
    constructor() {
        this.routes = [];
    }

    /**
     * 플러그인 단일 라우트를 생성합니다. (path: /plugins/:pluginName)
     * @returns {Array} 생성된 라우트 배열 (요소 1개)
     */
    generateRoutes() {
        this.routes = [
            {
                path: `${PLUGIN_BASE_PATH}/:pluginName`,
                name: "Plugin",
                component: SubmoduleLoader,
                props: true,
                meta: {
                    submodule: true,
                },
            },
        ];
        return this.routes;
    }

    /**
     * 플러그인 라우트 경로를 반환합니다. (/plugins/:pluginName 규칙)
     * @param {string} pluginName - 플러그인 이름
     * @returns {string} 라우트 경로
     */
    getSubmoduleRoutePath(pluginName) {
        return pluginName ? `${PLUGIN_BASE_PATH}/${pluginName}` : null;
    }

    /**
     * API/Store 기반이 아니므로 빈 배열 반환. (호환용)
     * @returns {Array}
     */
    getEnabledSubmodules() {
        return [];
    }

    /**
     * 호환용. 항상 true.
     * @returns {boolean}
     */
    isSubmoduleEnabled() {
        return true;
    }

    /**
     * 플러그인 라우트에 대한 네비게이션 가드를 생성합니다.
     * /plugins/:pluginName 접근 시 백엔드 activePluginNames로만 검사.
     * @param {Object} [store] - Vuex store
     * @returns {Function} 네비게이션 가드 함수
     */
    createNavigationGuard(store) {
        return (to, from, next) => {
            const pluginName = to.params && to.params.pluginName;
            const isPluginRoute = to.path.startsWith(`${PLUGIN_BASE_PATH}/`) && pluginName;

            if (isPluginRoute) {
                if (store && store.getters && Array.isArray(store.getters.activePluginNames)) {
                    if (!store.getters.activePluginNames.includes(pluginName)) {
                        console.warn(`플러그인 ${pluginName}이(가) 백엔드에서 비활성 상태입니다.`);
                        next({ path: "/plugin-connection" ,  query: { label: pluginName } });
                        return;
                    }
                }
            }

            next();
        };
    }
}

const submoduleRouter = new SubmoduleRouter();

export default submoduleRouter;
